import {
  fetchAllAssetFilters,
  fetchAssetProfileFn,
  fetchAttendees,
  fetchCompanyDelegates,
  fetchCompanyEvents,
  fetchCompanyProfileFn,
  fetchDelegateProfileFn,
  fetchEventGroupedAssetProfilesFn,
  fetchLatestAssetProfilesFn,
  fetchNewAssetsCount,
  markAssetsAsViewed,
} from './profile'
import { fetchDateRangeFn, fetchIsContactable, fetchPredictiveSearch, searchFn } from './search'

const api = {
  search: {
    key: 'FETCH_SEARCH_RESULTS_API_KEY',
    fn: searchFn,
  },
  getFilters: {
    key: 'FETCH_SEARCH_FILTERS_API_KEY',
    fn: searchFn,
  },
  getMetaFiltersData: {
    key: 'FETCH_SEARCH_META_FILTERS_API_KEY',
    fn: fetchDateRangeFn,
  },
  getCompanyProfile: {
    key: 'FETCH_COMPANY_PROFILE_API_KEY',
    fn: fetchCompanyProfileFn,
  },
  getDelegateProfile: {
    key: 'FETCH_DELEGATE_PROFILE_API_KEY',
    fn: fetchDelegateProfileFn,
  },
  getAssetProfile: {
    key: 'FETCH_ASSET_PROFILE_API_KEY',
    fn: fetchAssetProfileFn,
  },
  getLatestCompanyAssetProfiles: {
    key: 'FETCH_LATEST_COMPANY_ASSET_PROFILES_API_KEY',
    fn: fetchLatestAssetProfilesFn,
  },
  getEventGroupedCompanyAssetProfiles: {
    key: 'FETCH_EVENT_GROUPED_COMPANY_ASSET_PROFILES_API_KEY',
    fn: fetchEventGroupedAssetProfilesFn,
  },
  getFilterForAllAssetsPage: {
    key: 'FETCH_FILTERS_FOR_ALL_ASSETS_PAGE',
    fn: fetchAllAssetFilters,
  },
  getAttendees: {
    key: 'FETCH_ATTENDEES',
    fn: fetchAttendees,
  },
  getNewAssetsCount: {
    key: 'FETCH_NEW_ASSETS_COUNT',
    fn: fetchNewAssetsCount,
  },
  fetchIsContactable: {
    key: 'FETCH_IS_CONTACTABLE',
    fn: fetchIsContactable,
  },
  getCompanyEvents: {
    key: 'FETCH_COMPANY_EVENTS',
    fn: fetchCompanyEvents,
  },
  getCompanyDelegates: {
    key: 'FETCH_COMPANY_DELEGATES',
    fn: fetchCompanyDelegates,
  },
  getPredictiveSearch: {
    key: 'FETCH_PREDICTIVE_SEARCH',
    fn: fetchPredictiveSearch,
  },
  markAssetsAsViewed: {
    key: 'SET_ASSETS_AS_VIEWED',
    fn: markAssetsAsViewed,
  },
}

export default api
